module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/slider/slider.component.scss
// module id = ./src/app/shared/components/slider/slider.component.scss
// module chunks = main